import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import CreateIcon from '@material-ui/icons/Create';
import SearchIcon from '@material-ui/icons/Search';
import React, { Fragment } from 'react';

import { colorPalette } from '../../../../../theme';
import { useDialogState } from '../../../dialog/useDialogState';

export const SubscribePlexButton = React.memo(
  ({ className }: { className?: string }): React.ReactElement => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const [, setDialogState] = useDialogState();

    const handleClickBrowsePlexes = (): void => {
      setDialogState({ type: 'browse_plexes' });
    };
    const handleClickCreatePlex = (): void => {
      setDialogState({ type: 'new_plex' });
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = (): void => {
      setAnchorEl(null);
    };

    return (
      <Fragment>
        <IconButton className={className} onClick={handleClick} style={{ marginRight: 4 }}>
          <AddIcon style={{ color: colorPalette.primaryColorGreen.primary }} />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={anchorEl != null}
          onClose={handleClose}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          disableScrollLock={true}
        >
          <MenuItem
            dense
            button
            onClick={(): void => {
              handleClose();
              handleClickBrowsePlexes();
            }}
          >
            <ListItemIcon>
              <SearchIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Browse Plexes" />
          </MenuItem>

          <MenuItem
            dense
            button
            onClick={(): void => {
              handleClose();
              handleClickCreatePlex();
            }}
          >
            <ListItemIcon>
              <CreateIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Create Plex" />
          </MenuItem>
        </Menu>
      </Fragment>
    );
  }
);
